<script setup>
    // child component for AlternativeAddress.vue.
    // Receives existing info from parent, sends new data over for saving through emit.

    import { ref } from 'vue';

    const props = defineProps(['alternativeAddressInfo', 'saveErrorData']);
    defineEmits(['save-data', 'cancel-edit']);

    const alternativeAddressInfo = ref(props.alternativeAddressInfo);

</script>

<template>
    <div class="well" v-if="alternativeAddressInfo">
        <form>
            <div class="row">
                <label for="firma" class="col-sm-3 col-form-label">Anrede</label>
                <!-- Leider noch binär, muss so schnell es geht geändert werden! -->
                <div class="col-sm-9">
                    <select
                        id="firma"
                        name="firma"
                        :class="{
                            'form-control form-select': true,
                            'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.anrede === 'undefined'),
                            'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.anrede !== 'undefined'),
                        }"
                        v-model="alternativeAddressInfo.anrede">
                        <option value="Frau">Frau</option>
                        <option value="Herr">Herr</option>
                        <option value="Divers">Divers</option>
                        <option value="Firma">Firma</option>
                    </select>
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.anrede !== 'undefined')">
                        {{ props.saveErrorData.anrede[0] }}
                    </div>
                </div>
                <label for="lastName" class="col-sm-3 col-form-label">Nachname</label>
                <div class="col-sm-9">
                    <input id="lastName"
                    :class="{
                        'form-control': true,
                        'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.name1 === 'undefined'),
                        'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.name1 !== 'undefined'),
                    }"
                    v-model="alternativeAddressInfo.name1"
                    type="text" />
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.name1 !== 'undefined')">
                        {{ props.saveErrorData.name1[0] }}
                    </div>
                </div>
                <label for="firstName" class="col-sm-3 col-form-label">Vorname</label>
                <div class="col-sm-9">
                    <input id="firstName"
                    :class="{
                        'form-control': true,
                        'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.name2 === 'undefined'),
                        'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.name2 !== 'undefined'),
                    }"
                    v-model="alternativeAddressInfo.name2"
                    type="text" />
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.name2 !== 'undefined')">
                        {{ props.saveErrorData.name2[0] }}
                    </div>
                </div>
                <label for="street" class="col-sm-3 col-form-label">Straße</label>
                <div class="col-sm-9">
                    <input id="street"
                    :class="{
                        'form-control': true,
                        'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.strasse === 'undefined'),
                        'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.strasse !== 'undefined'),
                    }"
                    v-model="alternativeAddressInfo.strasse"
                    type="text" />
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.strasse !== 'undefined')">
                        {{ props.saveErrorData.strasse[0] }}
                    </div>
                </div>
                <label for="plz" class="col-sm-3 col-form-label">Postleitzahl</label>
                <div class="col-sm-9">
                    <input id="plz"
                    :class="{
                        'form-control': true,
                        'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.plz === 'undefined'),
                        'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.plz !== 'undefined'),
                    }"
                    v-model="alternativeAddressInfo.plz"
                    type="text" />
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.plz !== 'undefined')">
                        {{ props.saveErrorData.plz[0] }}
                    </div>
                </div>
                <label for="city" class="col-sm-3 col-form-label">Ort</label>
                <div class="col-sm-9">
                    <input id="city"
                        :class="{
                            'form-control': true,
                            'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.ort === 'undefined'),
                            'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.ort !== 'undefined'),
                        }"
                        v-model="alternativeAddressInfo.ort"
                        type="text"
                    />
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.ort !== 'undefined')">
                        {{ props.saveErrorData.ort[0] }}
                    </div>
                </div>
                <label class="col-sm-3 col-form-label" for="country">Land</label>
                <div class="col-sm-9">
                    <select v-model="alternativeAddressInfo.land"
                        :class="{
                            'form-control form-select': true,
                            'is-valid': (props.saveErrorData !== null && typeof props.saveErrorData.land === 'undefined'),
                            'is-invalid': (props.saveErrorData !== null && typeof props.saveErrorData.land !== 'undefined'),
                        }">
                        <option value="Deutschland">Deutschland</option>
                        <option value="Belgien">Belgien</option>
                        <option value="Niederlande">Niederlande</option>
                        <option value="Luxemburg">Luxemburg</option>
                        <option value="Frankreich">Frankreich</option>
                        <option value="Österreich">Österreich</option>
                        <option value="Schweiz">Schweiz</option>
                        <option value="Italien">Italien</option>
                        <option value="Rumänien">Rumänien</option>
                        <option value="Spanien">Spanien</option>
                    </select>
                    <div class="invalid-feedback" v-if="(props.saveErrorData !== null && typeof props.saveErrorData.land !== 'undefined')">
                        {{ props.saveErrorData.land[0] }}
                    </div>
                </div>
            </div>
        </form>

        <div class="table-footer">
            <button class="btn btn-link footer-button"
                type="submit"
                @click="$emit('save-data', alternativeAddressInfo)">
                Speichern
                <i class="far fa-lg fa-save"></i>
            </button>
            <button class="btn btn-link footer-button"
                type="submit"
                @click="$emit('cancel-edit')">
                Abbrechen
                <i class="fas fa-lg fa-times"></i>
            </button>
        </div>
    </div>
</template>
